<template>
  <span v-if="this.$route.params.jenis=='TMA'">
  <ChartPetugasTMAVue/>
  </span>
  <span v-else>
  <ChartPetugasOmbroVue/>
  </span>
</template>

<script>
import ChartPetugasOmbroVue from './ChartPetugasOmbro.vue'
import ChartPetugasTMAVue from './ChartPetugasTMA.vue'

  export default {
    name: 'Chart Petugas',
    data: () => ({
    }),
    components: {
      ChartPetugasTMAVue,
      ChartPetugasOmbroVue
    }
  }
</script>